var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEstrela(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2875 13.2551C21.8607 9.33307 22.6473 7.37207 23.9999 7.37207C25.3526 7.37207 26.1392 9.33307 27.7124 13.2551L27.7857 13.4377C28.6744 15.6534 29.1188 16.7613 30.0245 17.4347C30.9302 18.1081 32.1192 18.2145 34.497 18.4275L34.9269 18.466C38.8185 18.8145 40.7643 18.9888 41.1807 20.2267C41.597 21.4647 40.152 22.7794 37.2619 25.4088L36.2973 26.2863C34.8343 27.6174 34.1028 28.2829 33.7619 29.1551C33.6983 29.3178 33.6454 29.4845 33.6036 29.6542C33.3795 30.5635 33.5937 31.5289 34.0221 33.4599L34.1555 34.0609C34.9428 37.6096 35.3365 39.3839 34.6491 40.1493C34.3923 40.4352 34.0584 40.6412 33.6876 40.7423C32.6952 41.0131 31.2863 39.865 28.4684 37.5689C26.618 36.0611 25.6928 35.3072 24.6306 35.1376C24.2128 35.0709 23.7871 35.0709 23.3693 35.1376C22.307 35.3072 21.3819 36.0611 19.5315 37.5689C16.7136 39.865 15.3047 41.0131 14.3123 40.7423C13.9414 40.6412 13.6076 40.4352 13.3508 40.1493C12.6634 39.3839 13.0571 37.6096 13.8444 34.0609L13.9778 33.4599C14.4062 31.5289 14.6204 30.5635 14.3963 29.6542C14.3545 29.4845 14.3016 29.3178 14.238 29.1551C13.8971 28.2829 13.1656 27.6174 11.7026 26.2863L10.738 25.4088C7.84791 22.7794 6.40286 21.4647 6.81922 20.2267C7.23558 18.9888 9.18139 18.8145 13.073 18.466L13.5029 18.4275C15.8807 18.2145 17.0696 18.1081 17.9753 17.4347C18.881 16.7613 19.3254 15.6534 20.2142 13.4377L20.2875 13.2551Z",
    stroke: "white",
    strokeWidth: 1.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34 12L38 8",
    stroke: "white",
    strokeOpacity: 0.7,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40 32L44 36",
    stroke: "white",
    strokeOpacity: 0.7,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 40V45",
    stroke: "white",
    strokeOpacity: 0.7,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9672 11.8637L10 8.51764",
    stroke: "white",
    strokeOpacity: 0.7,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.73206 31L4 33.4641",
    stroke: "white",
    strokeOpacity: 0.7,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstrela);
export default __webpack_public_path__ + "static/media/estrela.472990f030efc6747047db33cfd28681.svg";
export { ForwardRef as ReactComponent };